/// <reference path="../../types/qrcode.d.ts" />

namespace SP {
    let instance: SystemApp = null;


    export class NotificationSystem {
        page = 1;
        pageCount = 1;
        showAll = false;
        buttonPrev = $("#notifications_prev");
        buttonNext = $("#notifications_next");
        buttonDismiss = $("#notifications_dismiss");
        buttonShowAll = $("#notifications_show_all");
        buttonDropdown = $("#notifications_dropdown");
        recipientContainer = $("#NotificationRecipientContainer");

        constructor() {
            this.buttonPrev.click(e => this.prev_notification(e));
            this.buttonNext.click(e => this.next_notification(e));
            this.buttonDismiss.click(e => this.dismiss_all_notification(e));
            this.buttonShowAll.click(e => this.show_all_notification(e));
            this.buttonDropdown.click(e => this.show(1));
        }

        dismiss_notification(e: JQuery.ClickEvent, id: string) {
            event.stopPropagation();
            event.preventDefault();
            this._dismiss_notification(id);
            return false;
        }

        prev_notification(e: JQuery.ClickEvent) {
            this.show(this.page - 1);
            event.stopPropagation();
            event.preventDefault();
            return false;
        }

        next_notification(e: JQuery.ClickEvent) {
            this.show(this.page + 1);
            event.stopPropagation();
            event.preventDefault();
            return false;
        }

        show_all_notification(e: JQuery.ClickEvent) {
            this.showAll = !this.showAll;
            this.show(1);
            event.stopPropagation();
            event.preventDefault();
            return false;
        }

        dismiss_all_notification(e: JQuery.ClickEvent) {
            //event.stopPropagation();
            //event.preventDefault();
            this._dismiss_notification("");
            //return false;
        }

        getNotificationCount() {
            var label = $(".label.notification_count");
            return parseInt(label.html());
        }

        async _dismiss_notification(id: string) {
            var c = this.getNotificationCount();

            if (id) c--;
            else c = 0;
            this.setNotificationCount(c);

            await SP.Notification.DismissNotifications(id);

            this.show(this.page);
        }

        async show(page: number) {
            page = Math.max(Math.min(page, this.pageCount), 1);
            var r = await SP.Notification.GetNotifications(this.showAll, 10, page);
            this.page = r.page;
            this.pageCount = r.pageCount;

            $("#notifications_small").empty();
            $("#notifications_small").scrollTop();
            $("#notification_page_info").html(`(${r.page} / ${r.pageCount})`);
            for (let i = 0; i < r.data.length; i++) {
                let note = r.data[i];

                let n = $(`
                    <li class='notification_all notification_${note.id}'>
                        <a class='notification-link' href="#" >
                            <table style='width:100%'>
                            <tr>
                                <td style='width: 40px;'><img src="${note.imageUrl}" style="margin-right:5px; max-height:30px; max-width:30px;" /></td>
                                <td>
                                    <small style='float:right; color:light-gray'>${note.date}</small>
                                    <b>${note.source}</b><br />${note.title}<br />
                                    <small><b>${note.customer}</b></small>
                                </td>
                                <td class='dismiss'><div>X</div></td>
                            </tr>
                            </table>
                        </a>
                    </li>
                `);

                if (this.showAll) n.find(".dismiss").remove();
                else n.find(".dismiss").click(e => this.dismiss_notification(e, note.id));

                $("#notifications_small").append(n);
            }

            if (this.page >= this.pageCount) {
                this.buttonNext.css("opacity", "0.2")
                this.buttonNext.css("pointerEvents", "none");

            }
            else {
                this.buttonNext.css("opacity", "1")
                this.buttonNext.css("pointerEvents", "");

            }

            if (this.page <= 1) {
                this.buttonPrev.css("opacity", "0.2")
                this.buttonPrev.css("pointerEvents", "none");

            }
            else {
                this.buttonPrev.css("opacity", "1")
                this.buttonPrev.css("pointerEvents", "");

            }
        }

        setNotificationCount(c: number) {
            $(".notification_count").html(c + "");
            $(".label.notification_count").css("display", c ? "block" : "none");
        }

        async showNotification(note: Notification) {
            this.setNotificationCount(this.getNotificationCount() + 1);

            let info = $(`
                <div style='display:none' class="notification">
                    <div class="hide_notification">x</div>
                    <a class="notification-link" href="#">
                        <table style="width:100%">
                            <tbody>
                                <tr>
                                    <td><img src="${note.imageUrl}" style="margin-right:5px; max-height:30px; max-width:30px;"></td>
                                    <td>
                                        <small style="float:right; color:light-gray">now</small>
                                        <b>${note.source}</b><br />${note.title}<br />
                                        <small><b>${note.customer}</b></small>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </a>
                </div>
            `);


            $(".notification-container").prepend(info);

            info.slideDown(400);
            info.find(".hide_notification").click(e => {
                info.hide();
                this._dismiss_notification(note.id);
            })

            let hover = false;
            info.mouseenter(() => { hover = true; });
            info.mouseleave(() => { hover = false; });
            while (true) {
                await SP.sleep(5000);
                if (!hover) break;
            }

            info.fadeOut(1000);
            await SP.sleep(1000);
            info.remove();

        }
    }


    export class SystemApp {
        hub = new SP.SignalRConnection("/wmshub/");
        barcodeEngine = new SP.BarcodeEngine();
        notificationSystem = new NotificationSystem();
        deviceId = -1;

        start() {
            let _reconnecting = false;

            let registerDevice = async () => {
                this.deviceId = parseInt(localStorage.getItem("wms_admin_deviceId") ?? "-1");
                let deviceId = await this.hub.connection.invoke("RegisterDevice", this.deviceId, 3);
                this.setDevice(deviceId);
            }

            this.hub.onDisconnect((error) => {
                if (!_reconnecting) {
                    _reconnecting = true;
                    console.log(error);
                    console.log("DISCONNECTED");
                }
            });

            this.hub.onReconnected(async () => {
                if (_reconnecting) {
                    //force reload current location app
                    await registerDevice();
                    console.log("RECONNECTED");
                    _reconnecting = false;
                }

            });




            this.hub.on("ScanBarcode", async (code: string) => {
                console.log("code:", code);
                var action = await this.barcodeEngine.performScan(code);
                if (!action) SP.typeInTextarea(code);
            });

            this.hub.on("Notification", (notification: Notification) => {
                this.notificationSystem.showNotification(notification);
            });


            this.hub.start(signalR.HttpTransportType.WebSockets, async () => {
                await registerDevice();
            });
        }

        setDevice(id: number) {
            this.deviceId = id;
            localStorage.setItem("wms_admin_deviceId", this.deviceId.toString());

            //clear
            var qr_container = document.getElementById("qrcode");
            if (qr_container) {
                qr_container.innerHTML = "";

                new QRCode(qr_container, {
                    text: "a_" + id,
                    width: 50,
                    height: 50,
                });
            }

            document.querySelectorAll(".terminal_name").forEach(item => item.innerHTML = id.toString());
        }



        static get Instance(): SystemApp {
            if (instance == null)
                instance = new SystemApp();
            return instance;
        }
    }

}